var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/rejectreason-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6dce28c3!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/rejectreason-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RejectReasonEdit.vue
// module id = 699
// module chunks = 1